import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvenimentGenealogicComponent } from './eveniment-genealogic.component';
import { AddEvenimentGenealogicComponent } from './add-eveniment-genealogic/add-eveniment-genealogic.component';
import { EditEvenimentGenealogicComponent } from './edit-eveniment-genealogic/edit-eveniment-genealogic.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        EvenimentGenealogicComponent,
        AddEvenimentGenealogicComponent,
        EditEvenimentGenealogicComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [EvenimentGenealogicComponent],
})
export class EvenimentGenealogicModule { }
